import { ErrorUtil } from '@/modules/common/utils/error.util.ts';
import { ErrorCode } from '@/modules/common/enums/error-code.ts';

const ALREADY_EXISTS_PATTERN = /уже существует/i;

export class FavoriteErrorUtil {
  static isAlreadyExists(error: unknown) {
    if (!ErrorUtil.isBodyStatus(error, ErrorCode.AlreadyExists)) {
      return false;
    }

    return ALREADY_EXISTS_PATTERN.test(ErrorUtil.getCommonError(error)?.error_message ?? '');
  }
}
